/*******************/
/*** SHOP SWIPER ***/
/*******************/

import Swiper, { Navigation, Pagination, Lazy, FreeMode } from 'swiper';
import "swiper/css";
import "swiper/css/lazy";
import "swiper/css/free-mode";

new Swiper('#shopSwiper', {
    modules: [Navigation],
    slidesPerView: 1,
    spaceBetween: 20,
    centerInsufficientSlides: true,
    grabCursor: true,
    navigation: {
        prevEl: '.swiper-button-prev',
        nextEl: '.swiper-button-next',
    },
    breakpoints: {
        768: {
            slidesPerView: 2,
            spaceBetween: 40,
        },
        1199: {
            slidesPerView: 3,
            spaceBetween: 80,
        }
    }
})

let timer: any;
let experienceSwiper = new Swiper('#experienceSwiper', {
    modules: [Navigation, Pagination, Lazy, FreeMode],
    preloadImages: false,
    lazy: true,
    watchSlidesProgress: true,
    slidesPerView: 'auto',
    spaceBetween: 20,
    centerInsufficientSlides: true,
    grabCursor: true,
    freeMode: true,
    navigation: {
        prevEl: '.swiper-button-prev',
        nextEl: '.swiper-button-next',
    },
    pagination: {
        el: '.swiper-pagination'
    },
})

new Swiper('#socialSwiper', {
    modules: [Navigation, Pagination],
    slidesPerView: 'auto',
    centerInsufficientSlides: true,
    spaceBetween: 20,
    grabCursor: true,
    navigation: {
        prevEl: '.social-swiper-button-prev',
        nextEl: '.social-swiper-button-next',
        disabledClass: 'social-swiper-button-disabled',
        lockClass: 'social-swiper-button-lock'
    },
    pagination: {
        el: '.swiper-pagination'
    },
})

const observer = new IntersectionObserver((entries, observer) => {
    entries.forEach((entry) => {
        if (entry.isIntersecting) {
            // console.log('entroo');
            
            experienceSwiper.update()
            observer.disconnect()
        }
    })
})

const target = document.querySelector('.mxbudqtr-experience')
if (target) observer.observe(target)